import React from 'react';
import type { StoryCell, StoryboardProject } from '../types';
import { getCanvasSize } from '../model/factories';
import { ElementArt, SceneArt } from './Artwork';

interface CellSvgProps extends React.SVGProps<SVGSVGElement> {
  project: StoryboardProject;
  cell: StoryCell;
  includeMetadata?: boolean;
}

export const CellSvg = React.forwardRef<SVGSVGElement, CellSvgProps>(
  ({ project, cell, includeMetadata = false, ...props }, ref) => {
    const { width, height } = getCanvasSize(project.layout.aspectRatio);
    const elements = [...cell.elements].sort((a, b) => a.zIndex - b.zIndex);
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        role="img"
        aria-label={`${cell.title}. ${cell.description}`}
        {...props}
      >
        {includeMetadata && <title>{`${project.title} — ${cell.title}`}</title>}
        <SceneArt scene={cell.scene} width={width} height={height} prefix={`${project.id}-${cell.id}`} />
        {elements.map((element) => <ElementArt key={element.id} element={element} />)}
      </svg>
    );
  },
);
CellSvg.displayName = 'CellSvg';
